import api from '../api/axios';

const getAll = () => {
  return api.get('/equipment-makes');
};

const getById = (id) => {
  return api.get(`/equipment-makes/${id}`);
};

const create = (item) => {
  return api.post('/equipment-makes', item);
};

const update = (id, data) => {
  return api.patch(`/equipment-makes/${id}`, data);
};

const remove = (id) => {
  return api.delete(`/equipment-makes/${id}`);
};

const restore = (id) => {
  return api.get(`/equipment-makes/${id}/restore`);
};

const equipmentMakesServices = {
  getAll,
  getById,
  create,
  update,
  remove,
  restore,
};

export default equipmentMakesServices;

